import { enqueueNotification, SnackbarItem } from '@core/features/snackbar';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { heroApiService } from '@services/.';
import { ExtraReducer, getSideEffectState } from '@utils/.';
import { LocationReducerProps } from '../type';
import { RootState } from '@core/configureStore';
import { fetchCurrentUser } from '@core/features/auth/thunks';

export const updateLanguage = createAsyncThunk(
  'business/updateLanguage',
  async (language: string, thunkApi) => {
    try {
      const {
        auth: { user },
      } = thunkApi.getState() as RootState;
      if (!user) throw new Error('No user found');
      const selectedLocation = user.selected_location;

      await heroApiService.updateLanguage(selectedLocation.location_id, language);
      await thunkApi.dispatch(fetchCurrentUser());
      thunkApi.dispatch(
        enqueueNotification({
          name: `Update language of location ${selectedLocation.title}`,
          description: 'Successfully updated language',
          type: 'Success',
        } as SnackbarItem)
      );
    } catch (error: any) {
      thunkApi.dispatch(
        enqueueNotification({
          name: 'Failed to update language',
          description: 'There was error updating language. Please try again',
          type: 'Error',
        } as SnackbarItem)
      );
      throw new Error(error);
    }
  }
);

const [fulfilled, pending, rejected] = getSideEffectState(updateLanguage);

export const updateLanguageReducer = {
  [fulfilled]: (state, action) => {
    state.isLoading = false;
  },
  [rejected]: (state, action) => {
    state.isLoading = false;
  },
  [pending]: (state, action) => {
    state.isLoading = true;
  },
} as ExtraReducer<LocationReducerProps>;
